import axios from 'axios';
import Cookies from 'js-cookie';
import store from "@/store";

// Track 401 errors to prevent infinite loop
let auth401Count = 0;
const MAX_401_RETRIES = 2;
let lastAuthReset = Date.now();

const createAxiosInstance = (baseURL: string) => {
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    });


    instance.interceptors.request.use(config => {
        const token = Cookies.get('auth');
        //const authObject = authObjectStr ? JSON.parse(authObjectStr) : {};
        //const { token } = authObject;
        //console.log('token-------', token)
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
            config.baseURL = `${baseURL}/v2/public`;
        return config;
    });




    instance.interceptors.response.use(
        response => {
            // Reset 401 counter on successful response
            auth401Count = 0;
            return response;
        },
        error => {
            if (error.response && error.response.status === 401 && error.response.data.message === "JWT is invalid.") {
                // Reset counter if more than 30 seconds have passed
                if (Date.now() - lastAuthReset > 30000) {
                    auth401Count = 0;
                }

                auth401Count++;
                lastAuthReset = Date.now();

                if (auth401Count >= MAX_401_RETRIES) {
                    // Too many 401s - stop the loop, show error to user
                    console.error('Multiple 401 errors detected. Stopping re-authentication loop.');
                    store.currentUser = null;
                    Cookies.remove('neatolabsToken');
                    // Don't set authExpired to prevent re-auth loop
                    if (typeof window !== 'undefined') {
                        window.location.href = '/auth-error?reason=token_rejected';
                    }
                } else {
                    store.currentUser = null;
                    Cookies.remove('neatolabsToken');
                    store.status.authExpired = true;
                }
            }
            return Promise.reject(error);
        }
    );
    return instance;
};

export default createAxiosInstance;
